import './pro-multifamily-resident-app-control/pro-multifamily-resident-app-control';
import './pro-multifamily-resident-home-control/pro-multifamily-resident-home-control';
import CarriageTabs from '../../scripts/components/CarriageTabs';
import SlidesToggle from '../../scripts/components/SlidesToggle';
import { activateSmartApartmentTab } from '../../snippets/smart-apartment/smart-apartment';

const { onReady } = window;

onReady(() => {
  activateSmartApartmentTab();
  SlidesToggle.init(
    document.querySelector('[data-smart-apartment-arrows]'),
    '8'
  );
  CarriageTabs.init(
    document.querySelector('[data-smart-apartment-tabs-panel]')
  );
});
